export default __webpack_public_path__ + "static/media/188.73ad2c4e.gif";